export default async function getImageFromId(id) {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/getImageFromId`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }), // Envia o ID no corpo da requisição
      });
  
      if (!response.ok) {
        throw new Error(`Erro: ${response.status}`);
      }
  
      return await response.json(); // Retorna o JSON com a imagem Base64
    } catch (error) {
      console.error("Erro ao buscar imagem:", error);
      return null;
    }
  }
  